export const EGrupoPermissoes = {
  SUPER_USUARIO: 13,
  LABORATORIO: 14,
  CADASTRO_LANCAMENTO: 15,
  GESTOR: 16,
  RELATORIOS_PESQUISA: 17,
  GESTOR_APROVACAO: 19,
  ENGENHEIRO: 20
};

// Tela de Fornecedor (BASE): só esses e-mails acessam, em qualquer contrato (nem admin/suporte).
// TODA VEZ QUE ALTERAR AQUI ALTERE NO RequireAcessoFornecedorBaseAttribute DO BACK
export const EMAILS_ACESSO_FORNECEDOR_BASE = ['thiago@consultegeo.com.br', 'jonatanc0511@gmail.com'];

// TODA VEZ QUE ALTERAR AQUI ALTERE NO ENUMS DO BACK
export enum EPermissoes {
  Administrativo = 1,
  CadastroObra = 2,
  Financeiro = 3,
  CadastrosBase = 4,
  Estoque = 5,
  CadastroProduto = 6,
  ConfiguracaoCliente = 7,
  Relatorio = 8,
  Relatorio_NaoConformidadeQualidade = 8010,
  Lancamento = 9,
  Portal_Usina = 10,
  Lancamento_Recebimento = 1010,
  Lancamento_Aplicacao = 1020,
  Lancamento_ResultadoEnsaios = 1030,
  Lancamento_Laudo = 1040,
  Lancamento_Laudo_Exclusao = 1049,
  Lancamento_Concretagem = 1050,
  Lancamento_Concretagem_Exclusao = 1059,
  Lancamento_Programacao = 1060,
  Lancamento_Programacao_EmailEdicao = 1065,
  Lancamento_Programacao_Exclusao = 1069,
  Aprovacao = 11,
  Aprovacao_Concretagem = 11010,
  Aprovacao_Laudo = 11020,
  NaoConformidade_Acao = 12010,
  NaoConformidade_Tipos = 12020,
  NaoConformidade_Configuracao = 12030,
  EmailAgendado_ResultadoInsatisfatorio = 20010,
  EmailAgendado_Pendencias = 20020
}

